import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import classnames from 'classnames';

import Pficon from 'components/Pficon';

import useTooltipTitle from './hooks/useTooltipTitle';
import { DATA_TEST_ID } from './constants';
import { getDataTestId } from './utils';

const HideButton = ({
  valueType,
  isDisabled = false,
  insideMatrix = false,
  insideNewMatrix = false,
  action,
  icon = 'close',
  iconClasses = '',
  buttonClasses = '',
  nodeType,
}) => {
  const title = useTooltipTitle(valueType, nodeType);
  const buttonElement = (
    <Button
      size="small"
      className={classnames([
        'border-none',
        'outline-blue',
        'padding-none',
        'shadow-none',
        'background-transparent',
        'line-height-clear',
        {
          'color-blue-6-hover': !isDisabled,
          'background-transparent-hover': isDisabled,
          'text-size-h4': !insideMatrix && !insideNewMatrix,
          'text-size-h5 margin-right-xs': insideMatrix,
          'text-size-h5 margin-none': insideNewMatrix,
        },
        buttonClasses,
      ])}
      onClick={action}
      disabled={isDisabled}
      data-testid={getDataTestId(valueType, DATA_TEST_ID.HIDE_BUTTON)}
    >
      <Pficon type={icon} className={iconClasses} />
    </Button>
  );

  if (isDisabled) {
    return buttonElement;
  }

  return (
    <Tooltip
      placement="bottomRight"
      arrowPointAtCenter
      overlayClassName="tooltip-light"
      trigger="hover"
      title={title}
    >
      {buttonElement}
    </Tooltip>
  );
};

HideButton.propTypes = {
  valueType: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  insideMatrix: PropTypes.bool,
  insideNewMatrix: PropTypes.bool,
  action: PropTypes.func.isRequired,
  icon: PropTypes.string,
  iconClasses: PropTypes.string,
  buttonClasses: PropTypes.string,
  nodeType: PropTypes.number,
};

export default React.memo(HideButton);
